module.exports = __webpack_public_path__ + "img/gianluca-cocco.1113a9dd.jpg";